var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}]},[_c('el-aside',[_c('RouterMenu',{attrs:{"menu-items":_vm.menuList},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.display))])]}}])})],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287e4976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Index.vue
// module id = null
// module chunks = 